import React from "react";
var __jsx = React.createElement;
import { memo, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import ZoneIndicator from "./ZoneIndicator";
import ScanFlowLayout from "./ScanFlowLayout";
import { ZONES, VOLUME_SWEEP_ZONE_LABELS } from "./types";
import { getVolumeSweepContentForZonePhase, getVolumeSweepSlidesConfig } from "./config/volumeSweepStepContent";
var VolumeSweepImaging = /*#__PURE__*/memo(function (_ref) {
  var _VOLUME_SWEEP_ZONE_LA;
  var zones = _ref.zones,
    currentZoneIndex = _ref.currentZoneIndex,
    currentPhase = _ref.currentPhase,
    _ref$isTransitioning = _ref.isTransitioning,
    isTransitioning = _ref$isTransitioning === void 0 ? false : _ref$isTransitioning,
    onNext = _ref.onNext,
    onSkip = _ref.onSkip,
    onJumpToZone = _ref.onJumpToZone,
    onClose = _ref.onClose,
    menuItems = _ref.menuItems,
    activeMenuItemId = _ref.activeMenuItemId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var currentZone = zones[currentZoneIndex];
  var currentZoneLetter = (currentZone === null || currentZone === void 0 ? void 0 : currentZone.zone) || "A";

  // Calculate overall progress for progress bar (top bar)
  var calculateOverallProgress = useCallback(function () {
    var stepsPerZone = 2; // transverse + longitudinal
    var completedZones = currentZoneIndex;
    var currentZoneSteps = currentPhase === "transverse" ? 0 : 1; // longitudinal or transitioning = 1

    var totalSteps = completedZones * stepsPerZone + currentZoneSteps + 1;
    return totalSteps / (ZONES.length * stepsPerZone) * 100;
  }, [currentZoneIndex, currentPhase]);
  var orientationLabel = (_VOLUME_SWEEP_ZONE_LA = VOLUME_SWEEP_ZONE_LABELS[currentZoneLetter]) !== null && _VOLUME_SWEEP_ZONE_LA !== void 0 ? _VOLUME_SWEEP_ZONE_LA : currentZoneLetter;
  var stepContent = useMemo(function () {
    return getVolumeSweepContentForZonePhase(currentZoneLetter, currentPhase, t);
  }, [currentZoneLetter, currentPhase, t]);
  return /*#__PURE__*/React.createElement(ScanFlowLayout, {
    title: t("volume_sweep_imaging", "Volume sweep imaging"),
    progress: calculateOverallProgress(),
    steps: ZONES,
    currentStepIndex: currentZoneIndex,
    buttonLabel: t("next", "Next"),
    onButtonClick: onNext,
    showSkip: true,
    isDisabled: isTransitioning,
    onSkip: onSkip,
    onStepClick: onJumpToZone,
    isStepDisabled: function isStepDisabled(index) {
      if (isTransitioning) return true;
      var z = zones[index];
      return Boolean((z === null || z === void 0 ? void 0 : z.transverse) && (z === null || z === void 0 ? void 0 : z.longitudinal));
    },
    isStepComplete: function isStepComplete(index) {
      var z = zones[index];
      return Boolean((z === null || z === void 0 ? void 0 : z.transverse) && (z === null || z === void 0 ? void 0 : z.longitudinal));
    },
    onClose: onClose,
    menuItems: menuItems,
    activeMenuItemId: activeMenuItemId
  }, /*#__PURE__*/React.createElement(ZoneIndicator, {
    zoneLetter: currentZoneLetter,
    phase: currentPhase,
    content: stepContent,
    slidesConfig: getVolumeSweepSlidesConfig(currentZoneLetter)
  }));
});
VolumeSweepImaging.displayName = "VolumeSweepImaging";
export default VolumeSweepImaging;